import React from 'react';

const DeactivateAccount = () => {
    return (
        <div className="w-full mt-8 mb-4 md:px-0"> {/* Added mobile padding for safety */}
            <div className="relative w-full min-h-[143px] bg-[#F5F5F5] rounded-md p-6 md:p-10 flex flex-col md:flex-row items-start md:items-center justify-between transition-all gap-4">

                <div className="flex flex-col w-full md:w-auto">
                    <h1 className="text-[#000000] text-[24px] md:text-[22px] font-semibold mb-2">
                        Deactivate account
                    </h1>
                    <p className="text-[#757575] text-[16px] font-normal md:text-[15px] leading-relaxed">
                        Once you deactivate your account you have ' <span className="text-[#424242]">3 months</span> ' till you lose all your data
                    </p>
                </div>

                <div className="flex items-center justify-between md:justify-end w-full md:w-auto gap-4 !mt-5 md:mt-0">
                    <span className="text-[#9E9E9E] text-[14px] font-medium whitespace-nowrap">
                        Coming Soon
                    </span>

                    <button
                        disabled
                        className="px-8 py-2.5 border border-[#BDBDBD] rounded-[5px] text-[#9E9E9E] text-[14px] font-bold bg-transparent cursor-not-allowed whitespace-nowrap"
                    >
                        Deactivate
                    </button>
                </div>
            </div>
        </div>
    );
};

export default DeactivateAccount;